import React from "react";
import { Link } from "react-router-dom";
import { Section, Eyebrow } from "@/components/PublicLayout";

const PILLARS = [
  ["Mastery over age", "Progression is determined by demonstrated understanding, not by the calendar. A student advances when ready."],
  ["Learning by teaching", "Students explain, present and teach — the fastest route to durable understanding."],
  ["Recorded oral explanation", "Daily spoken reasoning builds evidence of mastery and sharpens thinking."],
  ["Research from early childhood", "Every student produces, presents and shares work at their level."],
  ["Multilingual education", "French and English are core academic languages; Spanish by default (trilingual). German may be studied as a subject."],
  ["Evidence-based portfolios", "Assessment is living — quizzes, orals and projects build a transparent record."],
];

export default function EducationalModel() {
  return (
    <div>
      <div className="bg-ink text-paper">
        <Section className="py-20 md:py-28">
          <Eyebrow>The educational model</Eyebrow>
          <h1 className="font-serif text-4xl md:text-6xl tracking-tight max-w-4xl">Readiness determines progression. Not age.</h1>
          <p className="mt-6 max-w-2xl text-paper/70 text-lg leading-relaxed">Our ambition extends far beyond helping students "get ahead". A child may approach secondary-level algebra early — not by rushing, but with method, rigour and measurable proof of mastery.</p>
        </Section>
      </div>
      <Section className="py-16 md:py-24">
        <div className="grid gap-px bg-border border border-border md:grid-cols-2 lg:grid-cols-3">
          {PILLARS.map(([t, d], i) => (
            <div key={t} className="bg-paper p-8">
              <div className="font-mono text-xs text-heraldic">0{i + 1}</div>
              <div className="mt-3 font-serif text-2xl text-ink">{t}</div>
              <p className="mt-2 text-ink/65 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
        <div className="mt-14 border-l-2 border-heraldic pl-6 max-w-3xl">
          <p className="text-ink/70 leading-relaxed">A "Baccalauréat at 10" or a "doctorate at 18" is not a universal guarantee — it is a vision and a possibility for exceptional students, offered only when legally, academically and institutionally available. We present evidence and transparent pathways rather than superlatives.</p>
        </div>
        <div className="mt-10"><Link to="/apply" className="bg-heraldic text-white px-7 py-3.5 rounded-sm hover:bg-heraldic-700 transition-colors">Begin an application</Link></div>
      </Section>
    </div>
  );
}
